const translation = {
  toVerifiedTip: {
    coupon: 'cupón exclusivo del 100%',
    end: 'para el Plan Profesional de Dify.',
    front: 'Ahora eres elegible para el estado de Educación Verificada. Por favor, introduce tu información educativa a continuación para completar el proceso y recibir un',
  },
  form: {
    schoolName: {
      title: 'El nombre de tu escuela',
      placeholder: 'Ingrese el nombre oficial y completo de su escuela',
    },
    schoolRole: {
      option: {
        student: 'Estudiante',
        administrator: 'Administrador escolar',
        teacher: 'Profesor',
      },
      title: 'Tu rol en la escuela',
    },
    terms: {
      desc: {
        termsOfService: 'Términos de Servicio',
        privacyPolicy: 'Política de privacidad',
        and: 'y',
        front: 'Su información y uso del estado de Educación Verificada están sujetos a nuestra',
        end: '. Al enviar:',
      },
      option: {
        age: 'Confirmo que tengo al menos 18 años',
        inSchool: 'Confirmo que estoy inscrito o empleado en la institución indicada. Dify puede solicitar prueba de inscripción/empleo. Si falseo mi elegibilidad, acepto pagar cualquier tarifa que se haya eximido inicialmente en función de mi estado educativo.',
      },
      title: 'Términos y Acuerdos',
    },
  },
  emailLabel: 'Tu correo electrónico actual',
  submit: 'Enviar',
  submitError: 'Error en el envío del formulario. Por favor, inténtelo de nuevo más tarde.',
  successTitle: 'Tienes la educación Dify verificada',
  toVerified: 'Verifica la educación',
  successContent: 'Hemos emitido un cupón de descuento del 100% para el plan Dify Professional en tu cuenta. El cupón es válido por un año, por favor utilízalo dentro del período de validez.',
  learn: 'Aprende cómo obtener la verificación de la educación',
  rejectTitle: 'Su verificación educativa de Dify ha sido rechazada.',
  currentSigned: 'ACTUALMENTE CONECTADO COMO',
  rejectContent: 'Desafortunadamente, no eres elegible para el estado de Educación Verificada y, por lo tanto, no puedes recibir el exclusivo cupón del 100% para el Plan Profesional de Dify si utilizas esta dirección de correo electrónico.',
}

export default translation
